import { PropsWithChildren, ReactElement, useState } from "react";
import { AgentDashboardNavigationContext, AgentDashboardNavigationContextValue, WaitingTasksFilters } from "./AgentDashboardNavigationContext";

export default function AgentDashboardNavigationProvider({ children }: PropsWithChildren): ReactElement {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [pendingWaitingTasksFilters, setPendingWaitingTasksFilters] = useState<WaitingTasksFilters | null>(null);

  function openProfileMenu() {
    setIsProfileMenuOpen(true);
  }

  function closeProfileMenu() {
    setIsProfileMenuOpen(false);
  }

  function toggleProfileMenu() {
    setIsProfileMenuOpen(curr => !curr);
  }

  function showWaitingTasks(filters: WaitingTasksFilters) {
    setIsProfileMenuOpen(true);
    setPendingWaitingTasksFilters(filters);
  }

  function clearPendingWaitingTasksFilters() {
    setPendingWaitingTasksFilters(null);
  }

  const contextValue: AgentDashboardNavigationContextValue = [
    { isProfileMenuOpen, pendingWaitingTasksFilters },
    { openProfileMenu, closeProfileMenu, toggleProfileMenu, showWaitingTasks, clearPendingWaitingTasksFilters },
  ];

  return (
    <AgentDashboardNavigationContext.Provider value={contextValue}>
      {children}
    </AgentDashboardNavigationContext.Provider>
  );
}
